webpackJsonp([13643350389075],{

/***/ 59:
/***/ (function(module, exports, __webpack_require__) {

	!function(t,e,n,r,o){if("customElements"in n)o();else{if(n.AWAITING_WEB_COMPONENTS_POLYFILL)return void n.AWAITING_WEB_COMPONENTS_POLYFILL.then(o);var a=n.AWAITING_WEB_COMPONENTS_POLYFILL=f();a.then(o);var i=n.WEB_COMPONENTS_POLYFILL||"//cdnjs.cloudflare.com/ajax/libs/webcomponentsjs/2.0.2/webcomponents-bundle.js",s=n.ES6_CORE_POLYFILL||"//cdnjs.cloudflare.com/ajax/libs/core-js/2.5.3/core.min.js";"Promise"in n?c(i).then((function(){a.isDone=!0,a.exec()})):c(s).then((function(){c(i).then((function(){a.isDone=!0,a.exec()}))}))}function f(){var t=[];return t.isDone=!1,t.exec=function(){t.splice(0).forEach((function(t){t()}))},t.then=function(e){return t.isDone?e():t.push(e),t},t}function c(t){var e=f(),n=r.createElement("script");return n.type="text/javascript",n.readyState?n.onreadystatechange=function(){"loaded"!=n.readyState&&"complete"!=n.readyState||(n.onreadystatechange=null,e.isDone=!0,e.exec())}:n.onload=function(){e.isDone=!0,e.exec()},n.src=t,r.getElementsByTagName("head")[0].appendChild(n),n.then=e.then,n}}(0,0,window,document,(function(){var t,e;t=window,e=function(){return function(t){var e={};function n(r){if(e[r])return e[r].exports;var o=e[r]={i:r,l:!1,exports:{}};return t[r].call(o.exports,o,o.exports,n),o.l=!0,o.exports}return n.m=t,n.c=e,n.d=function(t,e,r){n.o(t,e)||Object.defineProperty(t,e,{enumerable:!0,get:r})},n.r=function(t){"undefined"!=typeof Symbol&&Symbol.toStringTag&&Object.defineProperty(t,Symbol.toStringTag,{value:"Module"}),Object.defineProperty(t,"__esModule",{value:!0})},n.t=function(t,e){if(1&e&&(t=n(t)),8&e)return t;if(4&e&&"object"==typeof t&&t&&t.__esModule)return t;var r=Object.create(null);if(n.r(r),Object.defineProperty(r,"default",{enumerable:!0,value:t}),2&e&&"string"!=typeof t)for(var o in t)n.d(r,o,function(e){return t[e]}.bind(null,o));return r},n.n=function(t){var e=t&&t.__esModule?function(){return t.default}:function(){return t};return n.d(e,"a",e),e},n.o=function(t,e){return Object.prototype.hasOwnProperty.call(t,e)},n.p="",n(n.s=5)}([function(t,e){t.exports=function(t){var e=[];return e.toString=function(){return this.map((function(e){var n=function(t,e){var n,r=t[1]||"",o=t[3];if(!o)return r;if(e&&"function"==typeof btoa){var a=(n=o,"/*# sourceMappingURL=data:application/json;charset=utf-8;base64,"+btoa(unescape(encodeURIComponent(JSON.stringify(n))))+" */"),i=o.sources.map((function(t){return"/*# sourceURL="+o.sourceRoot+t+" */"}));return[r].concat(i).concat([a]).join("\n")}return[r].join("\n")}(e,t);return e[2]?"@media "+e[2]+"{"+n+"}":n})).join("")},e.i=function(t,n){"string"==typeof t&&(t=[[null,t,""]]);for(var r={},o=0;o<this.length;o++){var a=this[o][0];"number"==typeof a&&(r[a]=!0)}for(o=0;o<t.length;o++){var i=t[o];"number"==typeof i[0]&&r[i[0]]||(n&&!i[2]?i[2]=n:n&&(i[2]="("+i[2]+") and ("+n+")"),e.push(i))}},e}},function(t,e,n){var r=n(3);t.exports="string"==typeof r?r:r.toString()},function(t,e,n){var r=n(4);t.exports="string"==typeof r?r:r.toString()},function(t,e,n){(t.exports=n(0)(!1)).push([t.i,"@-webkit-keyframes spin{0%{-webkit-transform:rotate(0);transform:rotate(0)}to{-webkit-transform:rotate(359deg);transform:rotate(359deg)}}@keyframes spin{0%{-webkit-transform:rotate(0);transform:rotate(0)}to{-webkit-transform:rotate(359deg);transform:rotate(359deg)}}@-webkit-keyframes burst{0%{-webkit-transform:scale(1);transform:scale(1);opacity:1}90%{-webkit-transform:scale(1.5);transform:scale(1.5);opacity:0}}@keyframes burst{0%{-webkit-transform:scale(1);transform:scale(1);opacity:1}90%{-webkit-transform:scale(1.5);transform:scale(1.5);opacity:0}}@-webkit-keyframes flashing{0%{opacity:1}45%{opacity:0}90%{opacity:1}}@keyframes flashing{0%{opacity:1}45%{opacity:0}90%{opacity:1}}@-webkit-keyframes fade-left{0%{-webkit-transform:translateX(0);transform:translateX(0);opacity:1}75%{-webkit-transform:translateX(-20px);transform:translateX(-20px);opacity:0}}@keyframes fade-left{0%{-webkit-transform:translateX(0);transform:translateX(0);opacity:1}75%{-webkit-transform:translateX(-20px);transform:translateX(-20px);opacity:0}}@-webkit-keyframes fade-right{0%{-webkit-transform:translateX(0);transform:translateX(0);opacity:1}75%{-webkit-transform:translateX(20px);transform:translateX(20px);opacity:0}}@keyframes fade-right{0%{-webkit-transform:translateX(0);transform:translateX(0);opacity:1}75%{-webkit-transform:translateX(20px);transform:translateX(20px);opacity:0}}@-webkit-keyframes fade-up{0%{-webkit-transform:translateY(0);transform:translateY(0);opacity:1}75%{-webkit-transform:translateY(-20px);transform:translateY(-20px);opacity:0}}@keyframes fade-up{0%{-webkit-transform:translateY(0);transform:translateY(0);opacity:1}75%{-webkit-transform:translateY(-20px);transform:translateY(-20px);opacity:0}}@-webkit-keyframes fade-down{0%{-webkit-transform:translateY(0);transform:translateY(0);opacity:1}75%{-webkit-transform:translateY(20px);transform:translateY(20px);opacity:0}}@keyframes fade-down{0%{-webkit-transform:translateY(0);transform:translateY(0);opacity:1}75%{-webkit-transform:translateY(20px);transform:translateY(20px);opacity:0}}@-webkit-keyframes tada{0%{-webkit-transform:scaleX(1);transform:scaleX(1)}10%,20%{-webkit-transform:scale3d(.95,.95,.95) rotate(-10deg);transform:scale3d(.95,.95,.95) rotate(-10deg)}30%,50%,70%,90%{-webkit-transform:scaleX(1) rotate(10deg);transform:scaleX(1) rotate(10deg)}40%,60%,80%{-webkit-transform:scaleX(1) rotate(-10deg);transform:scaleX(1) rotate(-10deg)}to{-webkit-transform:scaleX(1);transform:scaleX(1)}}@keyframes tada{0%{-webkit-transform:scaleX(1);transform:scaleX(1)}10%,20%{-webkit-transform:scale3d(.95,.95,.95) rotate(-10deg);transform:scale3d(.95,.95,.95) rotate(-10deg)}30%,50%,70%,90%{-webkit-transform:scaleX(1) rotate(10deg);transform:scaleX(1) rotate(10deg)}40%,60%,80%{-webkit-transform:rotate(-10deg);transform:rotate(-10deg)}to{-webkit-transform:scaleX(1);transform:scaleX(1)}}.bx-spin,.bx-spin-hover:hover{-webkit-animation:spin 2s linear infinite;animation:spin 2s linear infinite}.bx-tada,.bx-tada-hover:hover{-webkit-animation:tada 1.5s ease infinite;animation:tada 1.5s ease infinite}.bx-flashing,.bx-flashing-hover:hover{-webkit-animation:flashing 1.5s infinite linear;animation:flashing 1.5s infinite linear}.bx-burst,.bx-burst-hover:hover{-webkit-animation:burst 1.5s infinite linear;animation:burst 1.5s infinite linear}.bx-fade-up,.bx-fade-up-hover:hover{-webkit-animation:fade-up 1.5s infinite linear;animation:fade-up 1.5s infinite linear}.bx-fade-down,.bx-fade-down-hover:hover{-webkit-animation:fade-down 1.5s infinite linear;animation:fade-down 1.5s infinite linear}.bx-fade-left,.bx-fade-left-hover:hover{-webkit-animation:fade-left 1.5s infinite linear;animation:fade-left 1.5s infinite linear}.bx-fade-right,.bx-fade-right-hover:hover{-webkit-animation:fade-right 1.5s infinite linear;animation:fade-right 1.5s infinite linear}",""])},function(t,e,n){(t.exports=n(0)(!1)).push([t.i,'.bx-rotate-90{transform:rotate(90deg);-ms-filter:"progid:DXImageTransform.Microsoft.BasicImage(rotation=1)"}.bx-rotate-180{transform:rotate(180deg);-ms-filter:"progid:DXImageTransform.Microsoft.BasicImage(rotation=2)"}.bx-rotate-270{transform:rotate(270deg);-ms-filter:"progid:DXImageTransform.Microsoft.BasicImage(rotation=3)"}.bx-flip-horizontal{transform:scaleX(-1);-ms-filter:"progid:DXImageTransform.Microsoft.BasicImage(rotation=0, mirror=1)"}.bx-flip-vertical{transform:scaleY(-1);-ms-filter:"progid:DXImageTransform.Microsoft.BasicImage(rotation=2, mirror=1)"}',""])},function(t,e,n){"use strict";n.r(e),n.d(e,"BoxIconElement",(function(){return g}));var r,o,a,i,s=n(1),f=n.n(s),c=n(2),l=n.n(c),m="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(t){return typeof t}:function(t){return t&&"function"==typeof Symbol&&t.constructor===Symbol&&t!==Symbol.prototype?"symbol":typeof t},u=function(){function t(t,e){for(var n=0;n<e.length;n++){var r=e[n];r.enumerable=r.enumerable||!1,r.configurable=!0,"value"in r&&(r.writable=!0),Object.defineProperty(t,r.key,r)}}return function(e,n,r){return n&&t(e.prototype,n),r&&t(e,r),e}}(),d=(o=(r=Object).getPrototypeOf||function(t){return t.__proto__},a=r.setPrototypeOf||function(t,e){return t.__proto__=e,t},i="object"===("undefined"==typeof Reflect?"undefined":m(Reflect))?Reflect.construct:function(t,e,n){var r,o=[null];return o.push.apply(o,e),r=t.bind.apply(t,o),a(new r,n.prototype)},function(t){var e=o(t);return a(t,a((function(){return i(e,arguments,o(this).constructor)}),e))}),p=window,b={},y=document.createElement("template"),h=function(){return!!p.ShadyCSS};y.innerHTML='\n<style>\n:host {\n  display: inline-block;\n  font-size: initial;\n  box-sizing: border-box;\n  width: 24px;\n  height: 24px;\n}\n:host([size=xs]) {\n    width: 0.8rem;\n    height: 0.8rem;\n}\n:host([size=sm]) {\n    width: 1.55rem;\n    height: 1.55rem;\n}\n:host([size=md]) {\n    width: 2.25rem;\n    height: 2.25rem;\n}\n:host([size=lg]) {\n    width: 3.0rem;\n    height: 3.0rem;\n}\n\n:host([size]:not([size=""]):not([size=xs]):not([size=sm]):not([size=md]):not([size=lg])) {\n    width: auto;\n    height: auto;\n}\n:host([pull=left]) #icon {\n    float: left;\n    margin-right: .3em!important;\n}\n:host([pull=right]) #icon {\n    float: right;\n    margin-left: .3em!important;\n}\n:host([border=square]) #icon {\n    padding: .25em;\n    border: .07em solid rgba(0,0,0,.1);\n    border-radius: .25em;\n}\n:host([border=circle]) #icon {\n    padding: .25em;\n    border: .07em solid rgba(0,0,0,.1);\n    border-radius: 50%;\n}\n#icon,\nsvg {\n  width: 100%;\n  height: 100%;\n}\n#icon {\n    box-sizing: border-box;\n} \n'+f.a+"\n"+l.a+'\n</style>\n<div id="icon"></div>';var g=d(function(t){function e(){!function(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}(this,e);var t=function(t,e){if(!t)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return!e||"object"!=typeof e&&"function"!=typeof e?t:e}(this,(e.__proto__||Object.getPrototypeOf(e)).call(this));return t.$ui=t.attachShadow({mode:"open"}),t.$ui.appendChild(t.ownerDocument.importNode(y.content,!0)),h()&&p.ShadyCSS.styleElement(t),t._state={$iconHolder:t.$ui.getElementById("icon"),type:t.getAttribute("type")},t}return function(t,e){if("function"!=typeof e&&null!==e)throw new TypeError("Super expression must either be null or a function, not "+typeof e);t.prototype=Object.create(e&&e.prototype,{constructor:{value:t,enumerable:!1,writable:!0,configurable:!0}}),e&&(Object.setPrototypeOf?Object.setPrototypeOf(t,e):t.__proto__=e)}(e,HTMLElement),u(e,null,[{key:"getIconSvg",value:function(t,e){var n=this.cdnUrl+"/regular/bx-"+t+".svg";return"solid"===e?n=this.cdnUrl+"/solid/bxs-"+t+".svg":"logo"===e&&(n=this.cdnUrl+"/logos/bxl-"+t+".svg"),n&&b[n]||(b[n]=new Promise((function(t,e){var r=new XMLHttpRequest;r.addEventListener("load",(function(){this.status<200||this.status>=300?e(new Error(this.status+" "+this.responseText)):t(this.responseText)})),r.onerror=e,r.onabort=e,r.open("GET",n),r.send()}))),b[n]}},{key:"define",value:function(t){t=t||this.tagName,h()&&p.ShadyCSS.prepareTemplate(y,t),customElements.define(t,this)}},{key:"cdnUrl",get:function(){return"//unpkg.com/boxicons@2.0.9/svg"}},{key:"tagName",get:function(){return"box-icon"}},{key:"observedAttributes",get:function(){return["type","name","color","size","rotate","flip","animation","border","pull"]}}]),u(e,[{key:"attributeChangedCallback",value:function(t,e,n){var r=this._state.$iconHolder;switch(t){case"type":!function(t,e,n){var r=t._state;r.$iconHolder.textContent="",r.type&&(r.type=null),r.type=!n||"solid"!==n&&"logo"!==n?"regular":n,void 0!==r.currentName&&t.constructor.getIconSvg(r.currentName,r.type).then((function(t){r.type===n&&(r.$iconHolder.innerHTML=t)})).catch((function(t){console.error("Failed to load icon: "+r.currentName+"\n"+t)}))}(this,0,n);break;case"name":!function(t,e,n){var r=t._state;r.currentName=n,r.$iconHolder.textContent="",n&&void 0!==r.type&&t.constructor.getIconSvg(n,r.type).then((function(t){r.currentName===n&&(r.$iconHolder.innerHTML=t)})).catch((function(t){console.error("Failed to load icon: "+n+"\n"+t)}))}(this,0,n);break;case"color":r.style.fill=n||"";break;case"size":!function(t,e,n){var r=t._state;r.size&&(r.$iconHolder.style.width=r.$iconHolder.style.height="",r.size=r.sizeType=null),n&&!/^(xs|sm|md|lg)$/.test(r.size)&&(r.size=n.trim(),r.$iconHolder.style.width=r.$iconHolder.style.height=r.size)}(this,0,n);break;case"rotate":e&&r.classList.remove("bx-rotate-"+e),n&&r.classList.add("bx-rotate-"+n);break;case"flip":e&&r.classList.remove("bx-flip-"+e),n&&r.classList.add("bx-flip-"+n);break;case"animation":e&&r.classList.remove("bx-"+e),n&&r.classList.add("bx-"+n)}}},{key:"connectedCallback",value:function(){h()&&p.ShadyCSS.styleElement(this)}}]),e}());e.default=g,g.define()}])}, true?module.exports=e():"function"==typeof define&&define.amd?define([],e):"object"==typeof exports?exports.BoxIconElement=e():t.BoxIconElement=e()}));
	//# sourceMappingURL=boxicons.js.map

/***/ }),

/***/ 223:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/distributor.580ebc8e.svg";

/***/ }),

/***/ 86:
/***/ (function(module, exports) {

	module.exports = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0idXRmLTgiPz4NCjwhLS0gR2VuZXJhdG9yOiBBZG9iZSBJbGx1c3RyYXRvciAxOC4xLjEsIFNWRyBFeHBvcnQgUGx1Zy1JbiAuIFNWRyBWZXJzaW9uOiA2LjAwIEJ1aWxkIDApICAtLT4NCjxzdmcgdmVyc2lvbj0iMS4xIiBpZD0iQ2FtYWRhXzEiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgeG1sbnM6eGxpbms9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkveGxpbmsiIHg9IjBweCIgeT0iMHB4Ig0KCSB2aWV3Qm94PSIwIDAgMjYxLjggNzAuNCIgZW5hYmxlLWJhY2tncm91bmQ9Im5ldyAwIDAgMjYxLjggNzAuNCIgeG1sOnNwYWNlPSJwcmVzZXJ2ZSI+DQo8Zz4NCgk8Zz4NCgkJPGc+DQoJCQk8Zz4NCgkJCQk8Zz4NCgkJCQkJPHBhdGggZmlsbD0iIzNENjM5RSIgZD0iTTExNCwzLjNsLTIuOSw1LjVDMTA5LjUsOCwxMDYuMyw2LDEwMy44LDZjLTIuMywwLTMuNSwxLjEtMy41LDIuNmMwLjIsMi4yLDEuNywzLjUsNiw1LjMNCgkJCQkJCWM1LjQsMi4zLDgsNC43LDgsOS44YzAsNi4yLTQuNiwxMS4xLTEyLDExLjFjLTUuMiwwLTkuNi0yLjItMTItMy42bDIuNy01LjljMSwwLjcsNS41LDMuNSw4LjIsMy41YzIuOCwwLDQuMS0xLjQsNC4xLTMuOA0KCQkJCQkJcy0xLjgtMy40LTQuNy00LjZjLTUuOC0yLjQtOS4zLTUuMi05LjMtMTAuNmMwLTYsNS4zLTkuOCwxMS4zLTkuOEMxMDcuNSwwLDExMS43LDEuNywxMTQsMy4zeiIvPg0KCQkJCQk8cGF0aCBmaWxsPSIjM0Q2MzlFIiBkPSJNMTQ4LjcsMTcuMmMwLDEwLjUtNS4xLDE3LjYtMTUuOSwxNy42Yy0xMC42LDAtMTUuMy02LjItMTUuMy0xNi45YzAtMTAuNSw1LjEtMTcuOSwxNS45LTE3LjkNCgkJCQkJCUMxNDQuMSwwLDE0OC43LDYuNiwxNDguNywxNy4yeiBNMTI2LjUsMTcuNGMwLDYuOCwxLjUsMTEuNiw3LDExLjZjNC4zLDAsNi4yLTQuMSw2LjItMTEuMmMwLTYuOC0xLjUtMTEuOC03LTExLjgNCgkJCQkJCUMxMjguNCw1LjksMTI2LjUsMTAuMiwxMjYuNSwxNy40eiIvPg0KCQkJCQk8cGF0aCBmaWxsPSIjM0Q2MzlFIiBkPSJNMTUzLjcsMC41aDIxLjd2NmgtMTMuNHY3LjhoMTEuMmwtMSw2aC0xMC4ydjE0LjNoLTguM1YwLjV6Ii8+DQoJCQkJCTxwYXRoIGZpbGw9IiMzRDYzOUUiIGQ9Ik0yMDIuMywwLjVsLTEuMSw2LjFoLTcuOXYyOGgtOC4zdi0yOEgxNzdWMC41SDIwMi4zeiIvPg0KCQkJCQk8cGF0aCBmaWxsPSIjM0Q2MzlFIiBkPSJNMjA1LjUsMC41aDguM3YzNC4xaC04LjNWMC41eiIvPg0KCQkJCQk8cGF0aCBmaWxsPSIjM0Q2MzlFIiBkPSJNMjQwLjIsMC41aDguM3YzNC4xaC03LjFsLTkuNy0xNC43Yy0wLjktMS4zLTMtNC45LTMuOS02LjNjMC4yLDIuMSwwLjUsNiwwLjUsOGwwLjEsMTMuMWgtOC4zVjAuNWg2LjgNCgkJCQkJCWw5LjgsMTQuNmMxLjIsMS44LDMuMSw1LDQuMSw2LjVjLTAuMS0yLjEtMC40LTYtMC40LTguMUwyNDAuMiwwLjV6Ii8+DQoJCQkJPC9nPg0KCQkJCTxnPg0KCQkJCQk8cGF0aCBmaWxsPSIjM0Q2MzlFIiBkPSJNMTA1LjQsNDkuM2wtMS41LDMuNGMwLDAtMi45LTEuNS01LjItMS41Yy0xLjMsMC0yLjUsMC43LTIuNSwxLjljMCwxLjcsMS4xLDIuOSwzLjcsMy45DQoJCQkJCQljMy43LDEuNCw1LjksMyw1LjksNi44YzAsMy4zLTIuOCw2LjYtNy43LDYuNmMtMy45LDAtNy45LTIuMi03LjgtMi4xbDEuNi0zLjdjMCwwLDMuNSwyLjEsNS44LDIuMWMyLjEsMCwzLTAuOSwzLTIuMg0KCQkJCQkJYzAtMS41LTEuMS0yLjktMy4zLTMuN2MtNC41LTEuNy02LjMtMy43LTYuMy03LjFjMC0zLjMsMy4yLTYuMiw3LjQtNi4yQzEwMi4xLDQ3LjYsMTA1LjQsNDkuMywxMDUuNCw0OS4zeiIvPg0KCQkJCQk8cGF0aCBmaWxsPSIjM0Q2MzlFIiBkPSJNMTE1LjYsNDEuM2MwLDEuOC0xLjEsMy4xLTMsMy4xYy0xLjksMC0yLjktMS4zLTIuOS0yLjljMC0xLjgsMS4xLTMuMSwzLjEtMy4xDQoJCQkJCQlDMTE0LjUsMzguMywxMTUuNiwzOS42LDExNS42LDQxLjN6IE0xMTAuMSw2NS4yVjQ4LjFoNXYxNi43YzAsMS4zLDAuNCwxLjcsMS4yLDEuN2MwLjQsMCwxLjEtMC4xLDEuMS0wLjFsMC41LDMuMg0KCQkJCQkJYzAsMC0xLjEsMC42LTMuMSwwLjZDMTExLjgsNzAuMiwxMTAuMSw2OC4xLDExMC4xLDY1LjJ6Ii8+DQoJCQkJCTxwYXRoIGZpbGw9IiMzRDYzOUUiIGQ9Ik0xMzQuOCw0OS4zbC0xLjUsMy40YzAsMC0yLjktMS41LTUuMi0xLjVjLTEuMywwLTIuNSwwLjctMi41LDEuOWMwLDEuNywxLjEsMi45LDMuNywzLjkNCgkJCQkJCWMzLjcsMS40LDUuOSwzLDUuOSw2LjhjMCwzLjMtMi44LDYuNi03LjcsNi42Yy0zLjksMC03LjktMi4yLTcuOC0yLjFsMS42LTMuN2MwLDAsMy41LDIuMSw1LjgsMi4xYzIuMSwwLDMtMC45LDMtMi4yDQoJCQkJCQljMC0xLjUtMS4xLTIuOS0zLjMtMy43Yy00LjUtMS43LTYuMy0zLjctNi4zLTcuMWMwLTMuMywzLjItNi4yLDcuNC02LjJDMTMxLjUsNDcuNiwxMzQuOCw0OS4zLDEzNC44LDQ5LjN6Ii8+DQoJCQkJCTxwYXRoIGZpbGw9IiMzRDYzOUUiIGQ9Ik0xMzcuMiw0OC4xaDRsMC45LTUuMWw0LjEtMC45djYuMWg1LjRsLTAuNiwzLjZoLTQuOHYxM2MwLDEuNSwxLDEuOCwyLDEuOGMxLjcsMCwzLjQtMC42LDMuNC0wLjYNCgkJCQkJCWwwLjgsMy4zYzAsMC0yLjMsMS01LjYsMWMtMy4zLDAtNS42LTEuMy01LjYtNC45VjUxLjdoLTRWNDguMXoiLz4NCgkJCQkJPHBhdGggZmlsbD0iIzNENjM5RSIgZD0iTTE2NC4yLDQ3LjZjNS4yLDAsNy4zLDIuNyw3LjMsNi4yYzAsNC4yLTQuOSw3LjgtMTIuNiw3LjljMC4zLDIuNywxLjQsNSw0LjksNWMyLjYsMCw2LjItMS41LDYuMi0xLjUNCgkJCQkJCWwxLjMsMy4xYzAsMC0zLjgsMi04LjMsMmMtNi44LDAtOS41LTQuMy05LjUtMTAuN0MxNTMuNiw1MS43LDE1OC4yLDQ3LjYsMTY0LjIsNDcuNnogTTE1OC43LDU4LjZjNS42LTAuMiw3LjctMi43LDcuNy00LjgNCgkJCQkJCWMwLTEuNy0xLjEtMi44LTIuNy0yLjhDMTU5LjksNTEsMTU4LjgsNTUsMTU4LjcsNTguNnoiLz4NCgkJCQkJPHBhdGggZmlsbD0iIzNENjM5RSIgZD0iTTIwMC44LDcwVjU1LjdjMC0yLjUtMC43LTQtMi42LTRjLTIuMiwwLTQuOCwyLjYtNC44LDYuNlY3MGgtNVY1NS43YzAtMi41LTAuNy00LTIuNi00DQoJCQkJCQljLTIuNCwwLTQuOCwyLjgtNC44LDcuNFY3MGgtNVY1OC45YzAtNy0yLjItOS40LTIuMi05LjRsNC0xLjZjMCwwLDEuNiwxLjYsMi4yLDQuOGMxLjUtMy41LDQuNC01LDcuMy01YzMsMCw0LjYsMS43LDUuNCw0LjENCgkJCQkJCWMxLjYtMi45LDQuMy00LjEsNy00LjFjNC42LDAsNiwzLDYsNy42VjcwSDIwMC44eiIvPg0KCQkJCQk8cGF0aCBmaWxsPSIjM0Q2MzlFIiBkPSJNMjI5LDU5LjRjMCw3LDIuMSw5LjQsMi4xLDkuNGwtMy45LDEuNmMwLDAtMi0xLjgtMi4yLTUuNGMtMSwzLjUtMy4xLDUuMy02LjksNS4zDQoJCQkJCQljLTUuNSwwLTguMS00LjMtOC4xLTEwLjljMC02LjcsNC4zLTExLjYsMTAuNS0xMS42YzMuNSwwLDguMSwxLjIsOC41LDEuM1Y1OS40eiBNMjI0LDU4LjF2LTYuM2MtMC42LTAuMi0yLTAuNS0yLjktMC41DQoJCQkJCQljLTQuNCwwLTUuNywzLjItNS43LDcuN2MwLDQuMSwwLjMsNy44LDMuNSw3LjhDMjIxLjgsNjYuNywyMjQsNjIuNCwyMjQsNTguMXoiLz4NCgkJCQkJPHBhdGggZmlsbD0iIzNENjM5RSIgZD0iTTI0OC4yLDQ5LjNsLTEuNSwzLjRjMCwwLTIuOS0xLjUtNS4yLTEuNWMtMS4zLDAtMi41LDAuNy0yLjUsMS45YzAsMS43LDEuMSwyLjksMy43LDMuOQ0KCQkJCQkJYzMuNywxLjQsNS45LDMsNS45LDYuOGMwLDMuMy0yLjgsNi42LTcuNyw2LjZjLTMuOSwwLTcuOS0yLjItNy44LTIuMWwxLjYtMy43YzAsMCwzLjUsMi4xLDUuOCwyLjFjMi4xLDAsMy0wLjksMy0yLjINCgkJCQkJCWMwLTEuNS0xLjEtMi45LTMuMy0zLjdjLTQuNS0xLjctNi4zLTMuNy02LjMtNy4xYzAtMy4zLDMuMi02LjIsNy40LTYuMkMyNDQuOCw0Ny42LDI0OC4yLDQ5LjMsMjQ4LjIsNDkuM3oiLz4NCgkJCQk8L2c+DQoJCQk8L2c+DQoJCQk8bGluZWFyR3JhZGllbnQgaWQ9IlNWR0lEXzFfIiBncmFkaWVudFVuaXRzPSJ1c2VyU3BhY2VPblVzZSIgeDE9IjAiIHkxPSIzNC44MzQxIiB4Mj0iNzQuOTY3MyIgeTI9IjM0LjgzNDEiPg0KCQkJCTxzdG9wICBvZmZzZXQ9IjAuMjAzIiBzdHlsZT0ic3RvcC1jb2xvcjojNEU3QkIzIi8+DQoJCQkJPHN0b3AgIG9mZnNldD0iMC40NjcxIiBzdHlsZT0ic3RvcC1jb2xvcjojNDM2QkE1Ii8+DQoJCQkJPHN0b3AgIG9mZnNldD0iMC42NTM1IiBzdHlsZT0ic3RvcC1jb2xvcjojM0Q2MzlFIi8+DQoJCQk8L2xpbmVhckdyYWRpZW50Pg0KCQkJPHBhdGggZmlsbD0idXJsKCNTVkdJRF8xXykiIGQ9Ik02Mi40LDUxLjJjLTItMC4xLTMuNy0wLjYtNS4xLTEuNWMtMS0wLjYtMS42LTEuNS0yLjQtMi4zYy0xLjYtMS43LTQuNC0yLjItNy4yLTIuMw0KCQkJCWMtMi43LTAuMS01LjMsMC42LTcuMywxLjhjLTEsMC42LTEuOCwxLjItMi41LDJjLTEuNCwxLjUtMi4zLDMuNC0yLjMsNS41YzAsMiwwLjQsNCwyLDUuM2MwLjgsMC42LDEuNiwxLjIsMi4yLDEuOQ0KCQkJCWMwLjgsMSwxLjIsMi4yLDEuMSwzLjVjLTAuMiwzLjItMy42LDUuMy03LjYsNC45Yy0zLjktMC40LTcuMS0zLjEtNy4zLTYuMmMtMC4xLTEuNCwwLjUtMi43LDEuNS0zLjZjMC4yLTAuMiwwLjUtMC40LDAuOC0wLjYNCgkJCQljMS41LTEuMywyLjQtMy4yLDIuMy01LjRjMC0yLjMtMS4xLTQuNS0yLjgtNi4yYy0wLjMtMC4zLTAuNi0wLjUtMC45LTAuOGMtMi0xLjctNC42LTIuNy03LjMtMi44Yy0yLjEtMC4xLTQuMiwwLjEtNS4zLDEuMw0KCQkJCWMtMC44LDAuOS0xLjQsMi0yLjUsMi41Yy0wLjksMC41LTIuMSwwLjctMy4zLDAuN2MtMy44LTAuMi03LjUtMy4zLTguMy03LjFjLTAuOC00LDEuNy03LjUsNS45LTcuNWMxLjQsMCwyLjgsMC40LDQsMQ0KCQkJCWMxLjIsMC43LDIuMSwxLjgsMy4yLDIuN2MxLjUsMS40LDMuOCwxLjcsNiwxLjhjNiwwLjEsMTEtNC44LDEwLjktMTEuNGMtMC4xLTMtMC45LTUuOS0yLjktNy45Yy0wLjYtMC42LTEuMy0xLjEtMS44LTEuOA0KCQkJCWMtMS4zLTEuNy0yLjEtMy44LTIuMi02LjJjLTAuMy02LjIsNC4xLTEyLjEsMTAtMTIuN0MzOS40LTAuOSw0NC4zLDQuMyw0My45LDExYy0wLjEsMi4yLTAuOCw0LjMtMS45LDYNCgkJCQljLTAuOSwxLjQtMi4zLDIuNC0zLjQsMy42Yy0yLDEuOS0yLjUsNC45LTIuNiw3LjdjMCwyLjksMC45LDUuNCwyLjUsNy40YzAuNiwwLjgsMS40LDEuNCwyLjIsMi4xYzIsMS41LDQuNiwyLjQsNy41LDIuNA0KCQkJCWMzLDAsNi4xLTAuNSw4LjMtMi4zYzAuOS0wLjcsMS44LTEuNiwyLjgtMi4xYzEuOS0xLjEsNC4yLTEuNyw2LjUtMS43YzYuMiwwLDEwLjIsNC4zLDguOSw5LjNDNzMuNCw0OC4xLDY3LjksNTEuNSw2Mi40LDUxLjJ6Ig0KCQkJCS8+DQoJCTwvZz4NCgkJPHBhdGggZmlsbD0iIzNENjM5RSIgZD0iTTI1Ny40LTAuM2MwLjcsMCwxLjUsMC4yLDIuMiwwLjZjMC43LDAuNCwxLjIsMC45LDEuNiwxLjZjMC40LDAuNywwLjYsMS40LDAuNiwyLjJjMCwwLjgtMC4yLDEuNS0wLjYsMi4yDQoJCQljLTAuNCwwLjctMC45LDEuMi0xLjYsMS42Yy0wLjcsMC40LTEuNCwwLjYtMi4yLDAuNmMtMC44LDAtMS41LTAuMi0yLjItMC42Yy0wLjctMC40LTEuMi0wLjktMS42LTEuNmMtMC40LTAuNy0wLjYtMS40LTAuNi0yLjINCgkJCWMwLTAuOCwwLjItMS41LDAuNi0yLjJjMC40LTAuNywwLjktMS4yLDEuNi0xLjZDMjU2LTAuMSwyNTYuNy0wLjMsMjU3LjQtMC4zeiBNMjU3LjQsMC40Yy0wLjYsMC0xLjIsMC4yLTEuOCwwLjUNCgkJCWMtMC42LDAuMy0xLDAuOC0xLjQsMS40Yy0wLjMsMC42LTAuNSwxLjItMC41LDEuOGMwLDAuNiwwLjIsMS4yLDAuNSwxLjhzMC44LDEsMS40LDEuNGMwLjYsMC4zLDEuMiwwLjUsMS44LDAuNQ0KCQkJYzAuNiwwLDEuMi0wLjIsMS44LTAuNWMwLjYtMC4zLDEtMC44LDEuNC0xLjRjMC4zLTAuNiwwLjUtMS4yLDAuNS0xLjhjMC0wLjYtMC4yLTEuMi0wLjUtMS44Yy0wLjMtMC42LTAuOC0xLTEuNC0xLjQNCgkJCUMyNTguNywwLjYsMjU4LjEsMC40LDI1Ny40LDAuNHogTTI1NS41LDYuNVYxLjhoMS42YzAuNiwwLDEsMCwxLjIsMC4xYzAuMiwwLjEsMC40LDAuMiwwLjYsMC41YzAuMSwwLjIsMC4yLDAuNCwwLjIsMC43DQoJCQljMCwwLjMtMC4xLDAuNi0wLjQsMC45Yy0wLjIsMC4zLTAuNiwwLjQtMSwwLjRjMC4yLDAuMSwwLjMsMC4yLDAuNCwwLjJjMC4yLDAuMiwwLjQsMC41LDAuNywwLjlsMC42LDAuOWgtMC45bC0wLjQtMC43DQoJCQljLTAuMy0wLjYtMC42LTAuOS0wLjgtMS4xYy0wLjEtMC4xLTAuMy0wLjItMC42LTAuMmgtMC40djJIMjU1LjV6IE0yNTYuMywzLjhoMC45YzAuNCwwLDAuNy0wLjEsMC45LTAuMmMwLjItMC4xLDAuMi0wLjMsMC4yLTAuNQ0KCQkJYzAtMC4xLDAtMC4zLTAuMS0wLjRjLTAuMS0wLjEtMC4yLTAuMi0wLjMtMC4yYy0wLjEtMC4xLTAuNC0wLjEtMC44LTAuMWgtMC45VjMuOHoiLz4NCgk8L2c+DQo8L2c+DQo8L3N2Zz4NCg=="

/***/ }),

/***/ 111:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _gatsbyLink = __webpack_require__(10);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _softin = __webpack_require__(86);
	
	var _softin2 = _interopRequireDefault(_softin);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function Footer() {
	  return _react2.default.createElement(
	    'footer',
	    { className: 'footer py-5 px-4' },
	    _react2.default.createElement(
	      'div',
	      { className: 'd-md-flex justify-between' },
	      _react2.default.createElement(
	        'p',
	        { className: 'mr-auto font-inter' },
	        '\xA9 2021 Grav\xEDttem. Todos os direitos reservados.'
	      ),
	      _react2.default.createElement(
	        'span',
	        { className: 'd-inline-flex' },
	        _react2.default.createElement(
	          'p',
	          { className: 'mr-2 text-md-right mt-10 ml-md-auto font-inter' },
	          'Desenvolvido por',
	          ' '
	        ),
	        _react2.default.createElement(
	          _gatsbyLink2.default,
	          { to: '/', className: 'w-25 h-50' },
	          _react2.default.createElement('img', { alt: '', src: _softin2.default, className: 'w-75 h-100 mt-1' })
	        )
	      )
	    )
	  );
	}
	
	exports.default = Footer;
	module.exports = exports['default'];

/***/ }),

/***/ 112:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _distributor = __webpack_require__(225);
	
	var _distributor2 = _interopRequireDefault(_distributor);
	
	var _netcolite = __webpack_require__(226);
	
	var _netcolite2 = _interopRequireDefault(_netcolite);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function PageHeader(_ref) {
	  var landingName = _ref.landingName;
	
	  var logo = landingName === 'distributor' ? _distributor2.default : _netcolite2.default;
	  return _react2.default.createElement(
	    'header',
	    { className: 'px-8 d-flex background-white' },
	    _react2.default.createElement('img', { src: logo, className: 'new-landing-logo', alt: '' })
	  );
	}
	
	exports.default = PageHeader;
	module.exports = exports['default'];

/***/ }),

/***/ 225:
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,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"

/***/ }),

/***/ 808:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/banner.484babf4.jpg";

/***/ }),

/***/ 809:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/man.50a2445e.png";

/***/ }),

/***/ 810:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/work.298f83fb.png";

/***/ }),

/***/ 226:
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,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"

/***/ }),

/***/ 113:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var Button = function Button(_ref) {
	  var children = _ref.children,
	      className = _ref.className,
	      ghost = _ref.ghost,
	      onClick = _ref.onClick,
	      rest = _objectWithoutProperties(_ref, ['children', 'className', 'ghost', 'onClick']);
	
	  return _react2.default.createElement(
	    'button',
	    _extends({
	      className: 'btn ' + (ghost && 'btn-ghost') + ' ' + className + ' font-inter',
	      onClick: onClick
	    }, rest),
	    children
	  );
	};
	
	Button.propTypes = {
	  className: _propTypes2.default.string,
	  children: _propTypes2.default.node,
	  ghost: _propTypes2.default.bool,
	  onClick: _propTypes2.default.func
	};
	
	exports.default = Button;
	module.exports = exports['default'];

/***/ }),

/***/ 114:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// typeof window !== 'undefined' ? require('boxicons') : null
	
	var Card = function Card(_ref) {
	  var className = _ref.className,
	      children = _ref.children;
	  return _react2.default.createElement(
	    'div',
	    { className: 'card-container ' + className },
	    children
	  );
	};
	
	Card.propTypes = {
	  className: _propTypes2.default.string,
	  children: _propTypes2.default.node
	};
	
	exports.default = Card;
	module.exports = exports['default'];

/***/ }),

/***/ 115:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// eslint-disable-next-line no-unused-expressions
	typeof window !== 'undefined' ? __webpack_require__(59) : null;
	
	var FunctionContent = function FunctionContent(_ref) {
	  var className = _ref.className,
	      image = _ref.image,
	      title = _ref.title,
	      text = _ref.text,
	      iconColor = _ref.iconColor;
	  return _react2.default.createElement(
	    'div',
	    { className: '' + className },
	    _react2.default.createElement('box-icon', { name: image, color: iconColor, size: 'lg', className: 'my-3' }),
	    _react2.default.createElement(
	      'div',
	      { className: 'flex align-items-center' },
	      _react2.default.createElement(
	        'h4',
	        { className: 'font-bold text-black font-inter' },
	        title
	      )
	    ),
	    _react2.default.createElement(
	      'p',
	      { className: 'text-gray font-inter' },
	      text
	    )
	  );
	};
	
	FunctionContent.propTypes = {
	  className: _propTypes2.default.string,
	  image: _propTypes2.default.string,
	  title: _propTypes2.default.string,
	  text: _propTypes2.default.string
	};
	
	exports.default = FunctionContent;
	module.exports = exports['default'];

/***/ }),

/***/ 116:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _axios = __webpack_require__(57);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _FormComponents = __webpack_require__(110);
	
	var _Button = __webpack_require__(113);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var LandingForm = function (_React$Component) {
	  _inherits(LandingForm, _React$Component);
	
	  function LandingForm() {
	    _classCallCheck(this, LandingForm);
	
	    var _this = _possibleConstructorReturn(this, _React$Component.call(this));
	
	    _this.state = {
	      loading: false,
	      feedback: false,
	      form: {
	        email: {
	          value: '',
	          validation: false
	        },
	        telefone: {
	          value: '',
	          validation: false
	        },
	        empresa: {
	          value: '',
	          validation: false
	        }
	      }
	    };
	    _this.onSubmit = _this.onSubmit.bind(_this);
	    _this.handleChange = _this.handleChange.bind(_this);
	    return _this;
	  }
	
	  LandingForm.prototype.handleChange = function handleChange(event) {
	    var form = this.state.form;
	
	    var inputValidation = false;
	    if (event.target.required && event.target.value === '') {
	      inputValidation = true;
	    } else if (event.target.name === 'empresa' && event.target.value.length < 1) {
	      inputValidation = true;
	    } else if (event.target.type === 'telefone' && event.target.value.length < 10) {
	      inputValidation = true;
	    }
	    var inputValue = event.target.value;
	    var inputName = event.target.name;
	    form[inputName].value = inputValue;
	    form[inputName].validation = inputValidation;
	    this.setState({ form: form });
	  };
	
	  LandingForm.prototype.onSubmit = function onSubmit(e) {
	    var _this2 = this;
	
	    e.preventDefault();
	    var form = this.state.form;
	    var landingName = this.props.landingName;
	
	    this.setState({ loading: true, feedback: null });
	    _axios2.default.post('https://site-softin-back.vercel.app/api/subscribe', {
	      email: form.email.value,
	      telefone: form.telefone.value,
	      empresa: form.empresa.value,
	      tags: [landingName]
	    }).then(function (response) {
	      if (response.data.success) {
	        _this2.setState({
	          loading: false,
	          feedback: {
	            message: response.data.message,
	            type: 'success'
	          }
	        });
	      } else {
	        _this2.setState({
	          loading: false,
	          feedback: {
	            message: response.data.message,
	            type: 'warning'
	          }
	        });
	      }
	    }).catch(function () {
	      _this2.setState({
	        loading: false,
	        feedback: {
	          message: 'Não foi possível realizar esta operação, tente novamente mais tarde.',
	          type: 'err'
	        }
	      });
	    });
	  };
	
	  LandingForm.prototype.render = function render() {
	    var _state = this.state,
	        loading = _state.loading,
	        feedback = _state.feedback,
	        form = _state.form;
	    var _props = this.props,
	        textDecoration = _props.textDecoration,
	        buttonDescription = _props.buttonDescription,
	        buttonColor = _props.buttonColor;
	
	
	    return _react2.default.createElement(
	      'form',
	      { className: 'landing-form mb-3', onSubmit: this.onSubmit },
	      _react2.default.createElement(_FormComponents.Input, {
	        required: true,
	        label: 'E-mail',
	        name: 'email',
	        type: 'email',
	        onChange: this.handleChange,
	        value: form.email.value,
	        validation: form.email.validation,
	        labelClassName: 'text-white'
	      }),
	      _react2.default.createElement(_FormComponents.Input, {
	        required: true,
	        label: 'Telefone',
	        name: 'telefone',
	        mask: '(99) 999999999',
	        onChange: this.handleChange,
	        value: form.telefone.value,
	        validation: form.telefone.validation,
	        labelClassName: 'text-white'
	      }),
	      _react2.default.createElement(_FormComponents.Input, {
	        required: true,
	        label: 'Nome da empresa',
	        name: 'empresa',
	        onChange: this.handleChange,
	        value: form.empresa.value,
	        validation: form.empresa.validation,
	        labelClassName: 'text-white'
	      }),
	      feedback ? _react2.default.createElement(
	        'div',
	        { className: 'alert-' + feedback.type + ' mt-4 p-2' },
	        _react2.default.createElement(
	          'p',
	          { className: 'text-dark mb-0' },
	          feedback.message
	        )
	      ) : null,
	      _react2.default.createElement(
	        _Button2.default,
	        { noFlex: true, className: buttonColor + ' mt-4 w-100', type: 'submit' },
	        loading ? 'Enviando...' : buttonDescription
	      ),
	      _react2.default.createElement(
	        'h6',
	        { className: 'text-center text-white font-weight-normal mt-3 font-inter' },
	        'Ao entrar em contato, voc\xEA concorda com as',
	        ' ',
	        _react2.default.createElement(
	          'a',
	          {
	            href: 'https://app.gravittem.com/terms-of-services/',
	            rel: 'noopener noreferrer',
	            target: '_blank',
	            className: textDecoration
	          },
	          'Pol\xEDticas de privacidade, Termos de uso',
	          ' '
	        ),
	        ' ',
	        'e uso de cookies.'
	      )
	    );
	  };
	
	  return LandingForm;
	}(_react2.default.Component);
	
	exports.default = LandingForm;
	module.exports = exports['default'];

/***/ }),

/***/ 117:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = TimelineItem;
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function TimelineItem(_ref) {
	  var icon = _ref.icon,
	      iconType = _ref.iconType,
	      iconColor = _ref.iconColor,
	      title = _ref.title,
	      description = _ref.description,
	      last = _ref.last;
	
	  return _react2.default.createElement(
	    'li',
	    { className: 'timeline-item' },
	    !last && _react2.default.createElement('div', { className: 'timeline-tail' }),
	    _react2.default.createElement(
	      'span',
	      { className: 'timeline-icon' },
	      _react2.default.createElement('box-icon', { name: icon, color: iconColor, type: iconType })
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: 'timeline-content' },
	      _react2.default.createElement(
	        'h5',
	        { className: 'font-bold text-black font-inter' },
	        title
	      ),
	      _react2.default.createElement(
	        'p',
	        { className: 'text-gray font-inter' },
	        description
	      )
	    )
	  );
	}
	
	TimelineItem.propTypes = {
	  description: _propTypes2.default.string,
	  icon: _propTypes2.default.string,
	  iconType: _propTypes2.default.string,
	  last: _propTypes2.default.bool,
	  title: _propTypes2.default.string
	};
	module.exports = exports['default'];

/***/ }),

/***/ 358:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactHelmet = __webpack_require__(8);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _banner = __webpack_require__(808);
	
	var _banner2 = _interopRequireDefault(_banner);
	
	var _man = __webpack_require__(809);
	
	var _man2 = _interopRequireDefault(_man);
	
	var _work = __webpack_require__(810);
	
	var _work2 = _interopRequireDefault(_work);
	
	var _Card = __webpack_require__(114);
	
	var _Card2 = _interopRequireDefault(_Card);
	
	var _FunctionContent = __webpack_require__(115);
	
	var _FunctionContent2 = _interopRequireDefault(_FunctionContent);
	
	var _LandingForm = __webpack_require__(116);
	
	var _LandingForm2 = _interopRequireDefault(_LandingForm);
	
	var _TimelineItem = __webpack_require__(117);
	
	var _TimelineItem2 = _interopRequireDefault(_TimelineItem);
	
	var _Footer = __webpack_require__(111);
	
	var _Footer2 = _interopRequireDefault(_Footer);
	
	var _PageHeader = __webpack_require__(112);
	
	var _PageHeader2 = _interopRequireDefault(_PageHeader);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// eslint-disable-next-line no-unused-expressions
	typeof window !== 'undefined' && __webpack_require__(59);
	
	function IndexPage() {
	  return _react2.default.createElement(
	    'div',
	    null,
	    _react2.default.createElement(_PageHeader2.default, { landingName: 'distributor' }),
	    _react2.default.createElement(_reactHelmet2.default, {
	      title: 'Distributor \u2014 Softin Sistemas',
	      link: [{
	        rel: 'icon',
	        type: 'image/png',
	        sizes: '32x32',
	        href: __webpack_require__(223)
	      }]
	    }),
	    _react2.default.createElement(
	      'div',
	      {
	        className: 'content-container d-lg-flex mb-0 align-items-center',
	        style: {
	          background: 'url(' + _banner2.default + ') no-repeat fixed left'
	        }
	      },
	      _react2.default.createElement('img', {
	        alt: '',
	        className: 'd-none d-lg-block',
	        src: _banner2.default,
	        style: {
	          width: '-webkit-fill-available'
	        }
	      }),
	      _react2.default.createElement(
	        'div',
	        { className: 'p-2 p-md-5 img-position-absolute position-relative d-lg-flex mx-0 align-items-center' },
	        _react2.default.createElement(
	          'h1',
	          { className: 'font-bold text-white text-center text-md-left pb-4 pb-md-0 font-inter pr-lg-3' },
	          'Ferramenta para o gerenciamento de distribuidora de pe\xE7as'
	        ),
	        _react2.default.createElement(
	          _Card2.default,
	          { className: 'background-black' },
	          _react2.default.createElement(
	            'h3',
	            { className: 'text-white font-inter' },
	            'Preencha os campos abaixo para que nossa equipe entre em contato'
	          ),
	          _react2.default.createElement(_LandingForm2.default, {
	            buttonDescription: 'Entre em contato',
	            textDecoration: 'text-green',
	            buttonColor: 'btn-green',
	            landingName: 'Landing page distributor'
	          })
	        )
	      )
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: 'background-white py-3 pb-6' },
	      _react2.default.createElement(
	        'h1',
	        { className: 'font-bold text-center text-black m-5 font-inter' },
	        'Administre todo o fluxo de sua opera\xE7\xE3o'
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'row mx-4 justify-content-md-center' },
	        _react2.default.createElement(_FunctionContent2.default, {
	          className: 'col-12 col-md-4 col-xl-3',
	          title: 'Or\xE7amento de pe\xE7as',
	          text: 'Gerencia as etapas de venda desde o or\xE7amento de pe\xE7as, formas de pagamentos, eventuais descontos e muito mais',
	          image: 'chat',
	          iconColor: '#43a791'
	        }),
	        _react2.default.createElement(_FunctionContent2.default, {
	          className: 'col-12 col-md-4 col-xl-3',
	          title: 'Controle de estoque',
	          text: 'Mantenha uma gest\xE3o eficiente e precisa de seu estoque de pe\xE7as acompanhando desde o controle, recep\xE7\xE3o, armazenamento e aloca\xE7\xE3o de invent\xE1rio',
	          image: 'box',
	          iconColor: '#43a791'
	        }),
	        _react2.default.createElement(_FunctionContent2.default, {
	          className: 'col-12 col-md-4 col-xl-3',
	          title: 'Gest\xE3o financeira',
	          text: 'Mantenha a sa\xFAde financeira do seu neg\xF3cio tando total controle do contas a pagar e receber, movimenta\xE7\xE3o de conta corrente e fluxo de caixa',
	          image: 'coin',
	          iconColor: '#43a791'
	        })
	      )
	    ),
	    _react2.default.createElement(
	      'h1',
	      {
	        className: 'font-bold text-center text-black p-5 mb-0 my-16 font-inter',
	        style: {
	          backgroundColor: '#fafafa'
	        }
	      },
	      'Entenda como funciona na pr\xE1tica'
	    ),
	    _react2.default.createElement(
	      'div',
	      {
	        className: 'content-container d-lg-flex align-items-center mx-2',
	        style: {
	          backgroundColor: '#fafafa'
	        }
	      },
	      _react2.default.createElement('img', { alt: '', className: 'w-100 img-sizing', src: _work2.default }),
	      _react2.default.createElement(
	        'div',
	        { className: 'p-5 ml-auto mx-0' },
	        _react2.default.createElement(_TimelineItem2.default, {
	          icon: 'user-detail',
	          iconType: 'solid',
	          iconColor: '#43a791',
	          title: 'Identifica\xE7\xE3o do cliente',
	          description: 'Realizar cadastro do cliente, com as informa\xE7\xF5es necess\xE1rias para efetuar a venda'
	        }),
	        _react2.default.createElement(_TimelineItem2.default, {
	          icon: 'file',
	          iconColor: '#43a791',
	          title: 'Venda das pe\xE7as',
	          description: 'Efetuar uma venda de balc\xE3o ou, caso seja necess\xE1rio, efetuar um or\xE7amento das pe\xE7as aguardando posteriormente a aprova\xE7\xE3o do mesmo para dar continuidade na efetiva\xE7\xE3o da venda'
	        }),
	        _react2.default.createElement(_TimelineItem2.default, {
	          icon: 'paper-plane',
	          iconColor: '#43a791',
	          title: 'Emiss\xE3o',
	          description: 'Emita documento fiscal atrav\xE9s do m\xF3dulo Grav\xEDttem Tax'
	        }),
	        _react2.default.createElement(_TimelineItem2.default, {
	          icon: 'box',
	          iconColor: '#43a791',
	          title: 'Controle de estoque',
	          description: 'Ao efetuar a emiss\xE3o do documento fiscal, ser\xE1 efetuada a baixa da pe\xE7a no estoque'
	        }),
	        _react2.default.createElement(_TimelineItem2.default, {
	          icon: 'coin',
	          iconColor: '#43a791',
	          title: 'Financeiro',
	          description: 'Gere o contas a receber da venda efetuada e tenha controle do contas a pagar atrav\xE9s do recebimento das notas fiscais relacionadas as pe\xE7as adquiridas para o seu estoque',
	          last: true
	        })
	      )
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: 'background-green d-md-flex pb-6 px-3 px-md-5 px-md-8' },
	      _react2.default.createElement(
	        'div',
	        { className: 'pb-3 pb-md-0' },
	        _react2.default.createElement(
	          'h2',
	          { className: 'font-bold text-white pt-5 text-center text-md-left font-inter' },
	          'Conhe\xE7a o Grav\xEDttem e junte-se aos mais de 400 clientes espalhados no Brasil inteiro'
	        ),
	        _react2.default.createElement(_LandingForm2.default, {
	          buttonDescription: 'Fazer parte do Grav\xEDttem',
	          buttonColor: 'btn-dark-green',
	          textDecoration: 'text-white underline',
	          landingName: 'Landing page distributor'
	        })
	      ),
	      _react2.default.createElement('img', {
	        alt: '',
	        className: 'd-none d-lg-block w-50 align-self-end ml-md-5 img-sizing',
	        src: _man2.default
	      })
	    ),
	    _react2.default.createElement(_Footer2.default, null)
	  );
	}
	
	exports.default = IndexPage;
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-gravittem-distributor-2021-js-20f84f81aa33808f3a0b.js